// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --citibanamex-core-b-2: var(--blue-200);
}

/* --citibanamex-core-b-2 var(--citibanamex-core-b-2): #0062b3; */
.snackbar {
  position: fixed;
  z-index: 3;
  right: 0;
  left: 0;
  width: 1200px;
  margin: 0 auto;
}
.snackbar .snackbar-container {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  border-radius: 8px;
  box-shadow: 0 3px 6px 0 rgba(130, 167, 217, 0.32);
  padding: 19px 16px;
  width: 84%;
}
.snackbar .snackbar-container .snackbar-icon {
  margin-right: 12px;
  margin-top: 0;
}
.snackbar .snackbar-container .snackbar-icon i {
  font-weight: bold;
  font-size: larger;
}
.snackbar .snackbar-container.-warning {
  background-color: #fcd9d9;
}
.snackbar .snackbar-container.-warning .snackbar-icon {
  color: #ed1c24;
}
.snackbar .snackbar-container.-success {
  background-color: #dfffd9;
}
.snackbar .snackbar-container.-success .snackbar-icon {
  color: #093;
}
.snackbar .snackbar-container.-info {
  background-color: #e6f7ff;
}
.snackbar .snackbar-container.-info .snackbar-icon {
  color: #001E22;
}

.snackbar-icon {
  width: 20px;
  height: 20px;
  display: flex;
}

.-fade-short {
  animation: fade-short 2s normal forwards ease-in-out;
  animation-duration: 8s;
}

.-fade-long {
  animation: fade-long 2s normal forwards ease-in-out;
  animation-duration: 8s;
}

@keyframes fade-short {
  from {
    opacity: 1;
    bottom: -80px;
  }
  5% {
    bottom: 15px;
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
@keyframes fade-long {
  from {
    opacity: 1;
    bottom: -80px;
  }
  5% {
    bottom: 15px;
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
@media (max-width: 576px) {
  .snackbar {
    width: 100% !important;
  }
  .snackbar-container {
    margin: 0 3%;
    width: 94% !important;
  }
}
@media (min-width: 577px) and (max-width: 768px) {
  .snackbar {
    width: 576px !important;
  }
  .snackbar-container {
    margin: 0 3%;
    width: 95% !important;
  }
}
@media (min-width: 769px) and (max-width: 992px) {
  .snackbar {
    width: 768px !important;
  }
  .snackbar-container {
    margin: 0 3%;
    width: 95% !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .snackbar {
    width: 992px !important;
  }
  .snackbar-container {
    margin: 0 3%;
    width: 95% !important;
  }
}
@media only screen and (min-width: 1200px) {
  .snackbar-container {
    margin: 0 7% 0 8%;
    width: 84% !important;
  }
}
.notification-warning:before {
  content: "\\f13c";
}

.notification-information-circle:before {
  content: "\\f0af";
}`, "",{"version":3,"sources":["webpack://./projects/dashboard-new/public/assets/css/_color-palette.scss","webpack://./projects/dashboard-new/src/app/components/snackbar/snackbar.component.scss"],"names":[],"mappings":"AAAA;EAEA,uCAAA;ACAA;;ADKA,iEAAA;ACLA;EACE,eAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;AAIF;AAHE;EACE,aAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;AAKJ;AAJI;EACE,kBAAA;EACA,aAAA;AAMN;AALM;EACE,iBAAA;EACA,iBAAA;AAOR;AAJI;EACE,yBDDiB;ACOvB;AALM;EACE,cDnBe;AC0BvB;AAJI;EACE,yBDDqB;ACO3B;AALM;EACE,WDLe;ACYvB;AAJI;EACE,yBD5BgB;ACkCtB;AALM;EACE,cDZkB;ACmB1B;;AADA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAIF;;AADA;EACE,oDAAA;EACA,sBAAA;AAIF;;AADA;EACE,mDAAA;EACA,sBAAA;AAIF;;AADA;EACE;IACE,UAAA;IACA,aAAA;EAIF;EAFA;IACE,YAAA;IACA,UAAA;EAIF;EAFA;IACE,UAAA;EAIF;EAFA;IACE,UAAA;IACA,aAAA;EAIF;AACF;AADA;EACE;IACE,UAAA;IACA,aAAA;EAGF;EADA;IACE,YAAA;IACA,UAAA;EAGF;EADA;IACE,UAAA;EAGF;EADA;IACE,UAAA;IACA,aAAA;EAGF;AACF;AAAA;EACE;IACE,sBAAA;EAEF;EAAA;IACE,YAAA;IACA,qBAAA;EAEF;AACF;AACA;EACE;IACE,uBAAA;EACF;EACA;IACE,YAAA;IACA,qBAAA;EACF;AACF;AAEA;EACE;IACE,uBAAA;EAAF;EAEA;IACE,YAAA;IACA,qBAAA;EAAF;AACF;AAGA;EACE;IACE,uBAAA;EADF;EAGA;IACE,YAAA;IACA,qBAAA;EADF;AACF;AAGA;EACE;IACE,iBAAA;IACA,qBAAA;EADF;AACF;AAIA;EACE,gBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF","sourcesContent":[":root{\r\n\r\n--citibanamex-core-b-2: var(--blue-200);\r\n\r\n}\r\n\r\n$citibanamex-core-b-1: #17294d;\r\n/* --citibanamex-core-b-2 var(--citibanamex-core-b-2): #0062b3; */\r\n$citibanamex-core-b-3: #3db6f2;\r\n$citibanamex-core-r-1: #ed1c24;\r\n$digital-core-b-2-50: #e6f7ff;\r\n$digital-core-b-2-100: #aad2f2;\r\n$digital-core-b-2-200: #62b1d9;\r\n$digital-core-b-2-700: #00528c;\r\n$digital-core-b-2-900: #143666;\r\n$digital-core-black: #000;\r\n$digital-core-dark-gray: #5c5f66;\r\n$digital-core-fuchsia: #c6007e;\r\n$digital-core-fuchsia-50: #ffe6f7;\r\n$digital-core-gray: #8a8f99;\r\n$digital-core-information: #0062b3;\r\n$digital-core-light-gray: #d3daea;\r\n$digital-core-medium-gray: #939DA1;\r\n$digital-core-near-white: #f5f7fc;\r\n$digital-core-r-1-50: #ffe6e6;\r\n$digital-core-r-1-100: #fcd9d9;\r\n$digital-core-r-1-700: #c00;\r\n$digital-core-r-1-900: #900;\r\n$digital-core-slate-gray: #001E22;\r\n$digital-core-success: #093;\r\n$digital-core-success-50: #f4fff2;\r\n$digital-core-success-100: #dfffd9;\r\n$digital-core-success-700: #062;\r\n$digital-core-teal: #007377;\r\n$digital-core-teal-50: #e6ffff;\r\n$digital-core-ultra-light-gray: #f8f8f8;\r\n$digital-core-warning: #ff8c19;\r\n$digital-core-warning-50: #fff9d9;\r\n$digital-core-warning-900: #b35900;\r\n$digital-core-white: #fff;\r\n$digital-core-yellow-100: #fff2d9;\r\n$products-afore: #0b94d9;\r\n$products-ahorro-facil: #ff8080;\r\n$products-fondos-de-inversion: #0099e6;\r\n$products-gold: #998847;\r\n$products-hipotecario: #581466;\r\n$products-home-depot: #e57200;\r\n$products-la-verde: #004d2f;\r\n$products-nomina: #062;\r\n$products-patrimonial: #b4975a;\r\n$products-priority: #0e2a48;\r\n$products-rewards: #065c77;\r\n$products-telet-n: #653279;\r\n","@use '../../../../public/assets/css/color-palette';\r\n\r\n.snackbar {\r\n  position: fixed;\r\n  z-index: 3;\r\n  right: 0;\r\n  left: 0;\r\n  width: 1200px;\r\n  margin: 0 auto;\r\n  .snackbar-container {\r\n    display: flex;\r\n    flex-flow: row;\r\n    justify-content: flex-start;\r\n    border-radius: 8px;\r\n    box-shadow: 0 3px 6px 0 rgba(130, 167, 217, 0.32);\r\n    padding: 19px 16px;\r\n    width: 84%;\r\n    .snackbar-icon {\r\n      margin-right: 12px;\r\n      margin-top: 0;\r\n      i {\r\n        font-weight: bold;\r\n        font-size: larger;\r\n      }\r\n    }\r\n    &.-warning {\r\n      background-color: color-palette.$digital-core-r-1-100;\r\n      .snackbar-icon {\r\n        color: color-palette.$citibanamex-core-r-1;\r\n      }\r\n    }\r\n    &.-success {\r\n      background-color: color-palette.$digital-core-success-100;\r\n      .snackbar-icon {\r\n        color: color-palette.$digital-core-success;\r\n      }\r\n    }\r\n    &.-info {\r\n      background-color: color-palette.$digital-core-b-2-50;\r\n      .snackbar-icon {\r\n        color: color-palette.$digital-core-slate-gray;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.snackbar-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n}\r\n\r\n.-fade-short {\r\n  animation: fade-short 2s normal forwards ease-in-out;\r\n  animation-duration: 8s;\r\n}\r\n\r\n.-fade-long {\r\n  animation: fade-long 2s normal forwards ease-in-out;\r\n  animation-duration: 8s;\r\n}\r\n\r\n@keyframes fade-short {\r\n  from {\r\n    opacity: 1;\r\n    bottom: -80px;\r\n  }\r\n  5% {\r\n    bottom: 15px;\r\n    opacity: 1;\r\n  }\r\n  95% {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    display: none;\r\n  }\r\n}\r\n\r\n@keyframes fade-long {\r\n  from {\r\n    opacity: 1;\r\n    bottom: -80px;\r\n  }\r\n  5% {\r\n    bottom: 15px;\r\n    opacity: 1;\r\n  }\r\n  95% {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .snackbar {\r\n    width: 100% !important;\r\n  }\r\n  .snackbar-container {\r\n    margin: 0 3%;\r\n    width: 94% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 577px) and (max-width: 768px) {\r\n  .snackbar {\r\n    width: 576px !important;\r\n  }\r\n  .snackbar-container {\r\n    margin: 0 3%;\r\n    width: 95% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 992px) {\r\n  .snackbar {\r\n    width: 768px !important;\r\n  }\r\n  .snackbar-container {\r\n    margin: 0 3%;\r\n    width: 95% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 992px) and (max-width: 1200px) {\r\n  .snackbar {\r\n    width: 992px !important;\r\n  }\r\n  .snackbar-container {\r\n    margin: 0 3%;\r\n    width: 95% !important;\r\n  }\r\n}\r\n@media only screen and (min-width: 1200px) {\r\n  .snackbar-container {\r\n    margin: 0 7% 0 8%;\r\n    width: 84% !important;\r\n  }\r\n}\r\n\r\n.notification-warning:before {\r\n  content: '\\F13C';\r\n}\r\n\r\n.notification-information-circle:before {\r\n  content: '\\F0AF';\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
